import { render, staticRenderFns } from "./AppsTabsComponent.vue?vue&type=template&id=4f9e069a&scoped=true&"
import script from "./AppsTabsComponent.vue?vue&type=script&lang=ts&"
export * from "./AppsTabsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AppsTabsComponent.vue?vue&type=style&index=0&id=4f9e069a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9e069a",
  null
  
)

export default component.exports